import React, { useEffect, useState } from 'react';
import './CheckoutCard.css';
import { Trash } from '@phosphor-icons/react';

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const CheckoutCard = (props) => {

    const item = props.item;
    const removeFromCart = props.removeFromCart;

    const product_link = `/shipping-container/${item.container_location_name}/${item.product_id}`

    return (
        <div className={`CartCard ${props.className}`}>
            <div className="CartCardImage" style={{backgroundImage: `url(/pimgV2/${item.product_id}/${item.container_photo_id}.webp)`}}>    
                <a href={product_link}>
                    <div className='CardCartImageBlur'>
                        <img src={`/pimgV2/${item.product_id}/${item.container_photo_id}.webp`} alt="" />
                    </div>
                </a>
            </div>
            <div className="InnerCartCard">
                <a href={product_link}>
                    <h5 className='no-block-start no-block-end CardTitle'>{item.container_iso_description}</h5><br />
                    <h5 className='no-block-start no-block-end'>{item.container_number}</h5>
                </a>
                <div className="d-flex space-between align-center">
                    <span>${numberWithCommas((item.total_price * 1.1).toFixed(2))} Inc. GST</span>
                    {
                        props.allowRemove !== false ?
                        <Trash className='pointer' style={{width: "2em", height: "2em"}} onClick={async ()=> {
                            removeFromCart(item.product_id, item.quantity);
                        }} />
                        :
                        <div></div>
                    }
                    
                </div>
            </div>
        </div>
    );
};

export default CheckoutCard;